import { ModalProp } from '@types';
import React from 'react';
import { ContentWrapper, Wrapper, HeaderWrapper, ContainerContentWrapper, CloseIcon, HeaderText } from './AlertModal.styled';
import Text from '@components/Text/Text';
import { UIConstants } from '@constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AlertModal: React.FC<ModalProp> = ({ title, showCloseIcon = true, handleClose, showHeaderWrapper = true, children, ...rest }) => {
    return (
        <Wrapper role="modal">
            <ContentWrapper {...rest} role="modalContent">
                {showHeaderWrapper && (
                    <HeaderWrapper>
                        <HeaderText data-testid="modal-header-text">
                            <Text textVariant="modalheadertext">{title}</Text>
                        </HeaderText>
                        {showCloseIcon && (
                            <CloseIcon
                                id="closeBtn"
                                data-testid="closeBtn"
                                src={UIConstants.closeIconWhite}
                                alt="close"
                                onClick={() => handleClose('close_modal')}
                            />
                        )}
                    </HeaderWrapper>
                )}
                <ContainerContentWrapper>{children}</ContainerContentWrapper>
            </ContentWrapper>
        </Wrapper>
    );
};

export default React.memo(AlertModal);
